import React, { useEffect } from 'react';

import { LocalStorageKey, localStorageUtil } from '@/utils/localStorage/localStorage.util.ts';

export const PostLoginController: React.FC = () => {
  useEffect(() => {
    const lastVisitedPage = localStorageUtil.getItem<string>({
      key: LocalStorageKey.LAST_VISITED_PAGE,
    });
    if (!lastVisitedPage) {
      return;
    }
    localStorageUtil.clearItem({ key: LocalStorageKey.LAST_VISITED_PAGE });
    window.location.href = lastVisitedPage;
  }, []);

  return null;
};
